// extracted by extract-css-chunks-webpack-plugin
module.exports = {"barChart":"_3U5Ynr"};